/**
 * Frontend feature-flag bootstrap for the media quarantine.
 *
 * Reads `REACT_APP_MEDIA_FEATURE_ENABLED` at build/start time. The
 * backend has the authoritative gate; this is purely a UX convenience
 * so we never RENDER a CTA into a flow the server will reject.
 *
 * Doctrine: when the flag is off, treat the surface as quarantined
 * for ALL roles in the UI. Admins still see admin-bypass affordances
 * exposed by `<QuarantinedRoute>` so they can verify the underlying
 * page is wired.
 */
const RAW = (process.env.REACT_APP_MEDIA_FEATURE_ENABLED || "false")
  .toString()
  .trim()
  .toLowerCase();

export const MEDIA_FEATURE_ENABLED = ["true", "1", "yes", "on"].includes(RAW);

/** Convenience guard for CTA visibility. */
export function mediaCtasVisible() {
  return MEDIA_FEATURE_ENABLED;
}
